// PerformanceItem.tsx

import { Avatar } from 'antd';
import { BDEPerformance } from '../../config/data';

interface PerformanceItemProps {
    bde: BDEPerformance;
    isHighPerforming: boolean;
}

const PerformanceItem: React.FC<PerformanceItemProps> = ({ bde, isHighPerforming }) => {
    const percentage = Math.round(bde.targetsAchieved * 100);

    // Determine background and text color based on performance
    const percentageBgColor = isHighPerforming && percentage >= 100 ? 'bg-green-100' : 'bg-red-100';
    const percentageTextColor = isHighPerforming && percentage >= 100 ? 'text-green-700' : 'text-red-700';

    // Apply a custom, lighter green/red for the specific look from the image
    const cardColorClass = percentage >= 97 ? 'bg-green-100' : 'bg-red-100'; // General logic for the green/red shade

    return (
        <div className="flex items-center py-3 border-b last:border-b-0 border-gray-100">
            {/* Left Section: Avatar and Details */}
            <div className="flex items-center space-x-3 w-3/4">
                <Avatar
                    size="large"
                    className="bg-gray-300 text-white font-semibold"
                    style={{ minWidth: '40px' }} // Ensures size consistency
                >
                    S
                </Avatar>
                <div>
                    <p className="text-gray-800 font-medium leading-none">{bde.name}</p>
                    <p className="text-gray-500 text-sm leading-none mt-2">{bde.code}</p>
                </div>
            </div>

            {/* Right Section: Percentage */}
            <div className="w-1/4 flex justify-end">
                <div
                    // Using a simple check for the image's specific colors:
                    className={`py-1 px-2.5 rounded text-sm font-semibold ${isHighPerforming ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'
                        }`}
                    style={{ minWidth: '55px', textAlign: 'center' }}
                >
                    {percentage}%
                </div>
            </div>
        </div>
    );
};

export default PerformanceItem;